/* eslint-disable no-unused-vars, max-len */
const { feWp } = window;
const { addAction, addFilter } = feWp.hooks;

// Use window.innerWidth (viewport) instead of screen.width (physical display)
// so that DevTools mobile simulation and real-device viewport changes are
// correctly detected by b3rg.js when firing b3rg_breakpoint_changed.
addFilter( 'b3rg_use_window_inner_width', 'b3rg/slider', () => true );

// Function to stop autoplay on the slider object
const stopAutoPlay = ( sliderObj ) => {
  sliderObj.autoplay.stop();
};

const updateProgressBar = ( swiper ) => {
  const progressBarFill = swiper.el.querySelector( '.swiper-pagination-progressbar-fill' );
  const activeSlide = swiper.realIndex + 1;
  const progress = ( ( activeSlide / ( swiper.originalSlideCount ) ) ) * 100;
  if ( progressBarFill ) {
    progressBarFill.style.width = progress + '%';
  }
};

const updateDots = ( swiper ) => {
  const dots = swiper.el.querySelectorAll( '.swiper-pagination-bullet' );
  dots.forEach( dot => {
    dot.addEventListener( 'click', () => {
      stopAutoPlay( swiper );
    } );
  } );
};

addAction(
  'b3rg_slider_init',
  'b3rg/slider',
  ( settings, el, swiper ) => {
    const isInfinite = settings.loop;
    const isProgressbar = settings.pagination?.type;
    const isAutoHeight = settings.autoHeight;

    // Skip infinite loop modifications when adaptive height is enabled to prevent slider getting stuck
    if ( isInfinite && !isAutoHeight ) {
      swiper.params.supports4k = true;
      swiper.params.longSwipesRatio = 0;
      swiper.params.threshold = 0;
      swiper.params.touchRatio = 0.1;
      swiper.params.autoplay = {
        delay: settings?.autoplay?.delay || 3000,
      };
      if ( isProgressbar ) {
        swiper.params.pagination = {
          el: '.swiper-pagination',
          type: 'custom',
          renderCustom: function ( swiper, current, total ) {
            return '<div class="swiper-pagination-wrpr"><span class="swiper-pagination-progressbar-fill"></span></div><div class="swiper-fraction-custom">' +
              current +
              '/' + ( swiper.originalSlideCount ) + '</div>';
          },
          renderFraction: function () {
            return '';
          }
        };
        el.querySelector( '.swiper-pagination' ).classList.add( 'swiper-pagination-custom' );
        swiper.on( 'slideChange', function () {
          updateProgressBar( this );
        } );
        swiper.on( 'init', function () {
          // Update the progress bar on initialization
          updateProgressBar( this );
        } );
      }
      swiper.update();
    }
    swiper.on( 'afterInit', ( swiper ) => {
      updateDots( swiper );
    } );

    const arrows = swiper.el.querySelectorAll( '.e-sld__btn' );
    arrows.forEach( arrow => {
      arrow.addEventListener( 'click', () => {
        stopAutoPlay( swiper );
      } );
    } );
    swiper.on( 'click', function () {
      stopAutoPlay( swiper );
    } );
    swiper.on( 'touchStart', function () {
      stopAutoPlay( swiper );
    } );
    // Prevent additional swipes during the transition
    swiper.on( 'slideChangeTransitionStart', () => {
      swiper.allowTouchMove = false;
    } );
    // Re-enable touch dragging after the transition
    swiper.on( 'slideChangeTransitionEnd', () => {
      swiper.allowTouchMove = true;
    } );
  },
  10,
  1,
);
